import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { AlertBoxMsg } from '@qrios/frontend-library';

import { PORTAL_PATH } from '../../../../../routes/paths';
import WithFormLayout from '../../../../../common/with-form-layout';
import { detailsValueFormatter } from '../../../../../../utils/details';
import DetailsWithButton from '../../../../../common/detailsWithButton';
import { formatToAmount } from '../../../../../../constants/helpers/utils';

import { AddFundsToTheWalletOrderResponse } from '../interfaces';

interface AddFundsToTheWalletOrderDetails extends AddFundsToTheWalletOrderResponse {
  transferAmount: number;
}

interface Props {
  orderDetails: AddFundsToTheWalletOrderDetails;
  onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    rowGap: theme.spacing(2)
  }
}));

const AddingFundsOrderConfirmation = ({ onClose, orderDetails }: Props) => {
  const history = useHistory();
  const classes = useStyles();

  const handleSubmitButton = () => {
    onClose();
  };

  const handleSecondaryButton = () => {
    history.push(PORTAL_PATH.WALLET_CREDITS_HISTORY);
    onClose();
  };

  return (
    <WithFormLayout
      submitLabel="Close"
      secondaryLabel="Open credits history"
      onSubmit={handleSubmitButton}
      onSecondary={handleSecondaryButton}
    >
      <Box mb={2}>
        <AlertBoxMsg severity="success">
          <Box>
            <span>
              We successfully confirmed your transfer order. Use information from below to finalize transfer. You can
              always back to this information in <b>Credits history</b> page.
            </span>
          </Box>
        </AlertBoxMsg>
      </Box>
      <Box mb={3}>
        <AlertBoxMsg severity="warning">
          <Box>
            <span>
              Make sure that the <b>Transfer narration</b> you entered is identical to the one provided below. It is
              necessary for the correct identification of your transaction in the system.
            </span>
          </Box>
        </AlertBoxMsg>
        <Box mt={3} className={classes.container}>
          <DetailsWithButton
            value={orderDetails.transferTitle}
            label="Transfer narration"
            hasCopyBtn={true}
            hasToastMessage={true}
            toastMessage="Copied transfer narration to clipboard"
            hasTooltipMessage={true}
            toooltipMessage="Copy transfer narration to clipboard"
          />
          <DetailsWithButton
            value={detailsValueFormatter(orderDetails.bankAccountNumber)}
            label="Account number (IBAN)"
            hasCopyBtn={true}
            hasToastMessage={true}
            toastMessage="Copied account number (IBAN) to clipboard"
            hasTooltipMessage={true}
            toooltipMessage="Copy account number (IBAN) to clipboard"
          />
          <DetailsWithButton
            value={formatToAmount(orderDetails.transferAmount)}
            valueForClipboard={orderDetails.transferAmount.toString()}
            label="Transfer amount"
            hasCopyBtn={true}
            hasToastMessage={true}
            toastMessage="Copied transfer amount to clipboard"
            hasTooltipMessage={true}
            toooltipMessage="Copy transfer amount to clipboard"
          />
          <DetailsWithButton
            value={detailsValueFormatter(orderDetails.bankName)}
            label="Bank name"
            hasCopyBtn={false}
          />
        </Box>
      </Box>
    </WithFormLayout>
  );
};
export default AddingFundsOrderConfirmation;
